module.exports = {
  title: '老干部信息服务管理系统',

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: false,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production',


  /**
   * 上传文件的前缀，
   * 因为后端springboot项目部署在网站子域下：http:*****:** api 下面，
   *  如果没有部署在子域下，改为 '' 即可
   */
  filebase: '/api',

  /**
   * 私钥
   */
  SMkey: "FA171555405706F73D7B973DB89F0B47",

  /**
   * 本地存储token的key
   */
  tokenKey: 'Cadres-Token',
  /**
   * 以下配置与服务端对应
   */
  //  JWT存储的请求头
  tokenHeader: "Authorization",
  //  JWT 负载中拿到开头
  tokenHead: 'Bearer'




}
